// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.product-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: var(--modal-overlay);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: var(--spacing-lg);
}
@supports ((-webkit-backdrop-filter: blur(10px)) or (backdrop-filter: blur(10px))) {
  .product-modal-overlay {
    -webkit-backdrop-filter: blur(10px);
            backdrop-filter: blur(10px);
  }
}

.product-modal {
  background: var(--modal-bg);
  border-radius: var(--modal-radius);
  box-shadow: var(--modal-shadow);
  max-width: 500px;
  width: 100%;
  max-height: 85vh;
  overflow: hidden;
  position: relative;
  animation: modalSlideIn 0.3s ease-out;
}
@media (max-width: 600px) {
  .product-modal {
    max-width: calc(100vw - 2rem);
    max-height: 90vh;
  }
}

.modal-content {
  padding: var(--modal-padding);
  color: var(--modal-color);
  overflow-y: auto;
  max-height: 85vh;
}
.modal-content::-webkit-scrollbar {
  width: 6px;
}
.modal-content::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}
.modal-content::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}
.modal-content::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

.product-header {
  margin-bottom: var(--spacing-xl);
}
.product-header .product-title {
  font-size: var(--font-size-h2);
  font-weight: var(--font-weight-semibold);
  color: var(--text-primary-light);
  margin: 0;
  line-height: var(--line-height-tight);
}

.ingredients-section {
  margin-bottom: var(--spacing-xl);
}
.ingredients-section .ingredients-text {
  font-size: var(--font-size-body);
  line-height: var(--line-height-normal);
  color: var(--text-secondary-light);
  margin: 0;
  text-align: justify;
}

.nutritional-table {
  margin-bottom: var(--spacing-xl);
}
.nutritional-table .table-header {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  font-size: var(--font-size-body);
  font-weight: var(--font-weight-semibold);
  color: var(--text-primary-light);
  margin-bottom: var(--spacing-md);
  padding-bottom: var(--spacing-sm);
  border-bottom: 2px solid #E5E5E5;
}
.nutritional-table .table-header .portion-info {
  font-size: var(--font-size-caption);
  font-weight: var(--font-weight-regular);
  color: var(--text-secondary-light);
}
.nutritional-table .nutrition-rows .nutrition-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: var(--spacing-sm) 0;
  border-bottom: 1px solid #F0F0F0;
}
.nutritional-table .nutrition-rows .nutrition-row:last-child {
  border-bottom: none;
}
.nutritional-table .nutrition-rows .nutrition-row .nutrition-label {
  font-size: var(--font-size-body);
  font-weight: var(--font-weight-medium);
  color: var(--text-primary-light);
  flex: 1;
}
.nutritional-table .nutrition-rows .nutrition-row .nutrition-value {
  font-size: var(--font-size-body);
  color: var(--text-secondary-light);
  text-align: right;
  min-width: 120px;
}

.allergen-section {
  margin-bottom: var(--spacing-xl);
}
.allergen-section .allergen-note {
  font-size: var(--font-size-caption);
  line-height: var(--line-height-normal);
  color: var(--text-secondary-light);
  margin: 0;
  padding: var(--spacing-md);
  background: #F8F9FA;
  border-radius: var(--border-radius-md);
  border-left: 3px solid var(--warning-color);
}

.close-button {
  width: 100%;
  background: var(--button-primary);
  color: #ffffff;
  padding: var(--spacing-md) var(--spacing-lg);
  border-radius: var(--border-radius-pill);
  font-size: var(--font-size-button);
  font-weight: var(--font-weight-medium);
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}
.close-button:hover {
  background: var(--vendomat-blue-dark);
  transform: translateY(-1px);
  box-shadow: var(--shadow-button-hover);
}
.close-button:active {
  transform: translateY(0);
  background: var(--vendomat-blue-dark);
}

@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: scale(0.9) translateY(-20px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}
@media (max-width: 768px) {
  .product-modal-overlay {
    padding: var(--spacing-md);
  }
  .modal-content {
    padding: var(--spacing-lg);
  }
  .nutritional-table .table-header {
    flex-direction: column;
    align-items: flex-start;
    gap: var(--spacing-xs);
  }
  .nutritional-table .table-header .portion-info {
    font-size: var(--font-size-small);
  }
  .nutritional-table .nutrition-row .nutrition-value {
    min-width: 100px;
    font-size: var(--font-size-caption);
  }
}
@media (max-width: 480px) {
  .product-header .product-title {
    font-size: var(--font-size-h3);
  }
  .ingredients-section .ingredients-text {
    font-size: var(--font-size-caption);
  }
  .nutritional-table .nutrition-row {
    flex-direction: column;
    align-items: flex-start;
    gap: var(--spacing-xs);
    padding: var(--spacing-xs) 0;
  }
  .nutritional-table .nutrition-row .nutrition-value {
    min-width: unset;
    text-align: left;
  }
}
@media (prefers-color-scheme: dark) {
  .product-modal {
    box-shadow: var(--shadow-dark-lg);
  }
}
.close-button:focus {
  outline: 2px solid var(--vendomat-blue-light);
  outline-offset: 2px;
}

@media print {
  .product-modal-overlay {
    position: static;
    background: white;
    padding: 0;
  }
  .product-modal {
    box-shadow: none;
    border: 1px solid #ccc;
    max-height: none;
  }
  .close-button {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/product-detail-modal/product-detail-modal.component.scss"],"names":[],"mappings":"AAGA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,0BAAA;AAFF;AAKE;EAdF;IAeI,mCAAA;YAAA,2BAAA;EAFF;AACF;;AAKA;EACE,2BAAA;EACA,kCAAA;EACA,+BAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EAGA,qCAAA;AAJF;AAME;EAbF;IAcI,6BAAA;IACA,gBAAA;EAHF;AACF;;AAMA;EACE,6BAAA;EACA,yBAAA;EACA,gBAAA;EACA,gBAAA;AAHF;AAME;EACE,UAAA;AAJJ;AAOE;EACE,mBAAA;EACA,kBAAA;AALJ;AAQE;EACE,mBAAA;EACA,kBAAA;AANJ;AASE;EACE,mBAAA;AAPJ;;AAYA;EACE,gCAAA;AATF;AAWE;EACE,8BAAA;EACA,wCAAA;EACA,gCAAA;EACA,SAAA;EACA,qCAAA;AATJ;;AAcA;EACE,gCAAA;AAXF;AAaE;EACE,gCAAA;EACA,sCAAA;EACA,kCAAA;EACA,SAAA;EACA,mBAAA;AAXJ;;AAgBA;EACE,gCAAA;AAbF;AAeE;EACE,aAAA;EACA,8BAAA;EACA,qBAAA;EACA,gCAAA;EACA,wCAAA;EACA,gCAAA;EACA,gCAAA;EACA,iCAAA;EACA,gCAAA;AAbJ;AAeI;EACE,mCAAA;EACA,uCAAA;EACA,kCAAA;AAbN;AAkBI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,4BAAA;EACA,gCAAA;AAhBN;AAkBM;EACE,mBAAA;AAhBR;AAmBM;EACE,gCAAA;EACA,sCAAA;EACA,gCAAA;EACA,OAAA;AAjBR;AAoBM;EACE,gCAAA;EACA,kCAAA;EACA,iBAAA;EACA,gBAAA;AAlBR;;AAyBA;EACE,gCAAA;AAtBF;AAwBE;EACE,mCAAA;EACA,sCAAA;EACA,kCAAA;EACA,SAAA;EACA,0BAAA;EACA,mBAAA;EACA,sCAAA;EACA,2CAAA;AAtBJ;;AA2BA;EACE,WAAA;EACA,iCAAA;EACA,cAAA;EACA,4CAAA;EACA,wCAAA;EACA,kCAAA;EACA,sCAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,yBAAA;EACA,sBAAA;AAxBF;AA0BE;EACE,qCAAA;EACA,2BAAA;EACA,sCAAA;AAxBJ;AA2BE;EACE,wBAAA;EACA,qCAAA;AAzBJ;;AA8BA;EACE;IACE,UAAA;IACA,uCAAA;EA3BF;EA6BA;IACE,UAAA;IACA,iCAAA;EA3BF;AACF;AA+BA;EACE;IACE,0BAAA;EA7BF;EAgCA;IACE,0BAAA;EA9BF;EAkCE;IACE,sBAAA;IACA,uBAAA;IACA,sBAAA;EAhCJ;EAkCI;IACE,iCAAA;EAhCN;EAqCI;IACE,gBAAA;IACA,mCAAA;EAnCN;AACF;AAwCA;EACE;IACE,8BAAA;EAtCF;EAyCA;IACE,mCAAA;EAvCF;EA0CA;IACE,sBAAA;IACA,uBAAA;IACA,sBAAA;IACA,4BAAA;EAxCF;EA0CE;IACE,gBAAA;IACA,gBAAA;EAxCJ;AACF;AA6CA;EACE;IACE,iCAAA;EA3CF;AACF;AA+CA;EACE,6CAAA;EACA,mBAAA;AA7CF;;AAiDA;EACE;IACE,gBAAA;IACA,iBAAA;IACA,UAAA;EA9CF;EAiDA;IACE,gBAAA;IACA,sBAAA;IACA,gBAAA;EA/CF;EAkDA;IACE,aAAA;EAhDF;AACF","sourcesContent":["// Product Detail Modal Component Styles\n// Based on white modal design from screenshots\n\n.product-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: var(--modal-overlay);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: var(--spacing-lg);\n\n  // Enable backdrop blur if supported\n  @supports (backdrop-filter: blur(10px)) {\n    backdrop-filter: blur(10px);\n  }\n}\n\n.product-modal {\n  background: var(--modal-bg);\n  border-radius: var(--modal-radius);\n  box-shadow: var(--modal-shadow);\n  max-width: 500px;\n  width: 100%;\n  max-height: 85vh;\n  overflow: hidden;\n  position: relative;\n  \n  // Animation entrance\n  animation: modalSlideIn 0.3s ease-out;\n\n  @media (max-width: 600px) {\n    max-width: calc(100vw - 2rem);\n    max-height: 90vh;\n  }\n}\n\n.modal-content {\n  padding: var(--modal-padding);\n  color: var(--modal-color);\n  overflow-y: auto;\n  max-height: 85vh;\n\n  // Custom scrollbar styling\n  &::-webkit-scrollbar {\n    width: 6px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: #f1f1f1;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: #c1c1c1;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #a8a8a8;\n  }\n}\n\n// Product Header\n.product-header {\n  margin-bottom: var(--spacing-xl);\n\n  .product-title {\n    font-size: var(--font-size-h2);\n    font-weight: var(--font-weight-semibold);\n    color: var(--text-primary-light);\n    margin: 0;\n    line-height: var(--line-height-tight);\n  }\n}\n\n// Ingredients Section\n.ingredients-section {\n  margin-bottom: var(--spacing-xl);\n\n  .ingredients-text {\n    font-size: var(--font-size-body);\n    line-height: var(--line-height-normal);\n    color: var(--text-secondary-light);\n    margin: 0;\n    text-align: justify;\n  }\n}\n\n// Nutritional Table\n.nutritional-table {\n  margin-bottom: var(--spacing-xl);\n\n  .table-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: baseline;\n    font-size: var(--font-size-body);\n    font-weight: var(--font-weight-semibold);\n    color: var(--text-primary-light);\n    margin-bottom: var(--spacing-md);\n    padding-bottom: var(--spacing-sm);\n    border-bottom: 2px solid #E5E5E5;\n\n    .portion-info {\n      font-size: var(--font-size-caption);\n      font-weight: var(--font-weight-regular);\n      color: var(--text-secondary-light);\n    }\n  }\n\n  .nutrition-rows {\n    .nutrition-row {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      padding: var(--spacing-sm) 0;\n      border-bottom: 1px solid #F0F0F0;\n\n      &:last-child {\n        border-bottom: none;\n      }\n\n      .nutrition-label {\n        font-size: var(--font-size-body);\n        font-weight: var(--font-weight-medium);\n        color: var(--text-primary-light);\n        flex: 1;\n      }\n\n      .nutrition-value {\n        font-size: var(--font-size-body);\n        color: var(--text-secondary-light);\n        text-align: right;\n        min-width: 120px;\n      }\n    }\n  }\n}\n\n// Allergen Information\n.allergen-section {\n  margin-bottom: var(--spacing-xl);\n\n  .allergen-note {\n    font-size: var(--font-size-caption);\n    line-height: var(--line-height-normal);\n    color: var(--text-secondary-light);\n    margin: 0;\n    padding: var(--spacing-md);\n    background: #F8F9FA;\n    border-radius: var(--border-radius-md);\n    border-left: 3px solid var(--warning-color);\n  }\n}\n\n// Close Button\n.close-button {\n  width: 100%;\n  background: var(--button-primary);\n  color: #ffffff;\n  padding: var(--spacing-md) var(--spacing-lg);\n  border-radius: var(--border-radius-pill);\n  font-size: var(--font-size-button);\n  font-weight: var(--font-weight-medium);\n  border: none;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n\n  &:hover {\n    background: var(--vendomat-blue-dark);\n    transform: translateY(-1px);\n    box-shadow: var(--shadow-button-hover);\n  }\n\n  &:active {\n    transform: translateY(0);\n    background: var(--vendomat-blue-dark);\n  }\n}\n\n// Modal Animation\n@keyframes modalSlideIn {\n  from {\n    opacity: 0;\n    transform: scale(0.9) translateY(-20px);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1) translateY(0);\n  }\n}\n\n// Responsive Design\n@media (max-width: 768px) {\n  .product-modal-overlay {\n    padding: var(--spacing-md);\n  }\n\n  .modal-content {\n    padding: var(--spacing-lg);\n  }\n\n  .nutritional-table {\n    .table-header {\n      flex-direction: column;\n      align-items: flex-start;\n      gap: var(--spacing-xs);\n\n      .portion-info {\n        font-size: var(--font-size-small);\n      }\n    }\n\n    .nutrition-row {\n      .nutrition-value {\n        min-width: 100px;\n        font-size: var(--font-size-caption);\n      }\n    }\n  }\n}\n\n@media (max-width: 480px) {\n  .product-header .product-title {\n    font-size: var(--font-size-h3);\n  }\n\n  .ingredients-section .ingredients-text {\n    font-size: var(--font-size-caption);\n  }\n\n  .nutritional-table .nutrition-row {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: var(--spacing-xs);\n    padding: var(--spacing-xs) 0;\n\n    .nutrition-value {\n      min-width: unset;\n      text-align: left;\n    }\n  }\n}\n\n// Dark mode adjustments for modal\n@media (prefers-color-scheme: dark) {\n  .product-modal {\n    box-shadow: var(--shadow-dark-lg);\n  }\n}\n\n// Focus management for accessibility\n.close-button:focus {\n  outline: 2px solid var(--vendomat-blue-light);\n  outline-offset: 2px;\n}\n\n// Print styles\n@media print {\n  .product-modal-overlay {\n    position: static;\n    background: white;\n    padding: 0;\n  }\n\n  .product-modal {\n    box-shadow: none;\n    border: 1px solid #ccc;\n    max-height: none;\n  }\n\n  .close-button {\n    display: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
